import { Component, OnInit, Renderer2, ViewChild, ElementRef, Directive } from '@angular/core';
import { ROUTES } from '../.././sidebar/sidebar.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { CtbConfService, PageBusquedaObject, CtbConfEmp, GralEmp, CtbCtaDefault } from '../../contabilidad/catalogo/ctb-conf/ctb-conf.service';
import { UsuarioService, GralUsrDto } from '../../contabilidad/catalogo/usuario/usuario.service';
import { GralUsr } from '../../contabilidad/entity/GralUsr';
import { LoginService } from '../../contabilidad/login/login.service';
import { DatePipe } from '@angular/common';
import Swal from 'sweetalert2';
import { EjercicioService } from './ejercicio.service';
import { PeriodoEjercicioService } from '../../contabilidad/control/periodo.service';
declare var bootstrap: any;
var misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0,
}
declare var $: any;

@Component({
  moduleId: module.id,
  selector: 'navbar-cmp',
  templateUrl: 'navbar.component.html',
  providers: [DatePipe, EjercicioService]
})

export class NavbarComponent implements OnInit {
  private listTitles: any[];
  usuario: GralUsr = new GralUsr();
  menu_visible = true;
  location: Location;
  private nativeElement: Node;
  private toggleButton;
  private sidebarVisible: boolean;
  public nombre_empresa = '';
  public dto: any = { id: 0 };
  public ejercicios: any[] = [{ periodos: [{}] }];
  public cargado = false;
  public periodos: any[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
  public ejercicio_vigente = 0;
  public periodo_vigente = 0;
  public ejercicio_object_selected: any = null;
  public periodo_object_selected: any = null;
  @ViewChild("navbar-cmp") button;

  constructor(private service: LoginService, private router: Router,
    location: Location, private renderer: Renderer2, private element: ElementRef, public datepipe: DatePipe,
    private ctbConfService: CtbConfService, private ejercicioService: EjercicioService, private PeriodoEjercicioService: PeriodoEjercicioService) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
    for (const empresa of this.service.empresas) {
      if (empresa.id == this.service.empresa) {
        this.nombre_empresa = empresa.titulo;
        break;
      }
    }
  }
  ocultar_menu_momentaneamente() {
    this.menu_visible = false;
    this.menu_visible = true;
  }
  logout() {
    this.service.logout();
    this.router.navigate(['pages/login']);
  }
  setPeriodoCerrado(cerrado: boolean) {
    localStorage.setItem('periodo_cerrado', cerrado === true ? 'true' : 'false');
  }
  seleccionarEjercicio(item: any, refresh: boolean) {
    this.ejercicio_object_selected = item;
    this.PeriodoEjercicioService.setEjercicioObject(this.ejercicio_object_selected);
    this.PeriodoEjercicioService.setEjercicio(this.ejercicio_object_selected.anio);
    //Obtener periodo vigente del ejercicio seleccionado
    this.periodo_object_selected = this.ejercicio_object_selected.periodos.find((p: any) => p.cerrado === false) || null;
    this.PeriodoEjercicioService.setPeriodoObject(this.periodo_object_selected);
    this.periodo_vigente = this.periodo_object_selected?.periodo || 0;
    this.PeriodoEjercicioService.setPeriodo(this.periodo_vigente);
    if(refresh){
      this.refrescar();
    }
  }
  refrescar() {
    location.reload();
  }
  crearEjercicio() {
    Swal.fire({
      title: 'Nuevo ejercicio',
      input: 'number',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Aceptar',
      showLoaderOnConfirm: true,
      preConfirm: (ejercicio) => {
        return fetch(`//api.github.com/users/${ejercicio}`)
          .then(response => {
            if (!response.ok) {
              throw new Error(response.statusText)
            }
            return response.json()
          })
          .catch(error => {
            Swal.showValidationMessage(
              `Request failed: ${error}`
            )
          })
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        let ejercicio = result.value.login
        let validado = true;
        for (let item of this.ejercicios) {
          if (Number(item.anio) === Number(ejercicio)) {
            validado = false;
          }
        }
        if (validado == true) {
          Swal.fire({
            title: '¿Está seguro de generar el ejercicio ' + ejercicio + '?',
            text: 'Vuelva a escribir el ejercicio para confirmar',
            showCancelButton: true,
            input: 'number',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Aceptar'
          }).then((result) => {
            if (Number(result.value) === Number(ejercicio)) {
              this.ejercicioService.crearEjercicio(this.service.usuario.empresa_seleccionada.id, ejercicio).subscribe(
                response => {
                  Swal.fire('TNK Ledger', response.mensaje, 'success');
                }, err => {
                  Swal.fire({
                    icon: 'error',
                    title: 'TNK Ledger',
                    text: err.error.mensaje
                  });
                }
              );
            } else {

              Swal.fire({
                icon: 'error',
                title: 'TNK Ledger',
                text: 'Los ejercicios no coinciden'
              });
            }
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: 'Ya existe un ejercicio ' + result.value.login
          });
        }


      }
    })
  }



    reabrirEjercicio() {
    Swal.fire({
      title: '¿Está seguro de realizar esta operación?',
text: 'Esta operación reabrirá el ejercicio y permitirá realizar modificaciones. Reabrir ejercicios o periodos cerrados puede causar inconsistencias contables e invalidará pólizas de cierre posteriores.',
showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {

        this.ejercicioService.reabrirEjercicio(this.ejercicio_object_selected.id, this.service.usuario.id).subscribe(
          response => {
            this.cargarEjercicios(true);
            Swal.fire('TNK Ledger', response.mensaje, 'success');
          }, err => {
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err.error.mensaje
            });
          }
        );
      } else if (result.isDenied) {

        this.router.navigate(['contabilidad/proceso/poliza-cierre']);
      }



    });
  }
  cerrarEjercicio() {
    Swal.fire({
      title: '¿Está seguro de realizar esta operación?',
      text: `Esta operación cerrará el ejercicio y no permitirá nuevas modificaciones.`,
      showCancelButton: true,
      showDenyButton: false,
      confirmButtonText: 'Aceptar',
      denyButtonText: "Póliza de cierre",
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {

        this.ejercicioService.cerrarEjercicio(this.ejercicio_object_selected.id, this.service.usuario.id).subscribe(
          response => {
            this.cargarEjercicios(true);
            Swal.fire('TNK Ledger', response.mensaje, 'success');
          }, err => {
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err.error.mensaje
            });
          }
        );
      } else if (result.isDenied) {

        this.router.navigate(['contabilidad/proceso/poliza-cierre']);
      }



    });
  }
  cerrarPeriodo(id: number) {
    Swal.fire({
      title: '¿Está seguro de realizar esta operación?',
      text: `Esta operación cerrará el periodo y abrirá el siguiente periodo automáticamente.`,
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: '¿Confirmar operación?',
          text: ``,
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar'
        }).then((result2) => {
          if (result2.value) {
            this.ejercicioService.
              cerrarPeriodo(id, this.service.usuario.id).subscribe(
                response => {
                  this.cargarEjercicios(true);
                  Swal.fire('TNK Ledger', response.mensaje, 'success');
                }, err => {
                  Swal.fire({
                    icon: 'error',
                    title: 'TNK Ledger',
                    text: err.error.mensaje
                  })
                }
              );
          }

        });
      }
    });
  }


  abrirPeriodo(id: number) {
    Swal.fire({
      title: '¿Está seguro de realizar esta operación?',
      text: `Esta operación abrirá el periodo y permitirá cambios o modificaciones, si tienes polizas de cierre en este periodo o posteriores, estas se invalidarán.`,
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          title: '¿Confirmar operación?',
          text: ``,
          showCancelButton: true,
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar'
        }).then((result2) => {
          if (result2.value) {
            this.ejercicioService.
              abrirPeriodo(id, this.service.usuario.id).subscribe(
                response => {
                  this.cargarEjercicios(true);
                  Swal.fire('TNK Ledger', response.mensaje, 'success');
                }, err => {
                  Swal.fire({
                    icon: 'error',
                    title: 'TNK Ledger',
                    text: err.error.mensaje
                  })
                }
              );
          }

        });
      }
    });
  }

  polizaCierrePeriodo(item: any) {
    if (item.poliza_cierre_periodo) {

      Swal.fire({
        title: 'Advertencia',
        text: 'Esta acción borrará la póliza de cierre del periodo y creará una nueva ¿Está seguro de volverla a generar?',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.irFormularioPolizaPeriodo();
        }
      });
    } else {

      this.irFormularioPolizaPeriodo();
    }

  }
  irFormularioPolizaPeriodo() {

    this.router.navigate(['contabilidad/proceso/poliza-cierre'], {
      queryParams: { tipo: 'Periodo' }
    });
  }





  cargarEjercicios(refrescar: boolean) {
    this.ejercicioService.getEjercicios(this.service.usuario.empresa_seleccionada?.id).subscribe(
      response => {
        this.ejercicios = response.contenido;
        //Ordenar los ejercicios por año de forma ascendente
        this.ejercicios.sort((a, b) => a.anio - b.anio);
        localStorage.setItem('ejercicios', JSON.stringify(this.ejercicios));
        if (this.ejercicios.length == 1) {
          this.ejercicio_object_selected = this.ejercicios[0];
        }
        if (this.ejercicio_object_selected) {
          const ejercicio_object_encontrado = this.ejercicios.find(e => e.id === this.ejercicio_object_selected.id);
          if (!ejercicio_object_encontrado) {
            this.ejercicio_object_selected = this.ejercicios[0];
          } else {
            this.ejercicio_object_selected = ejercicio_object_encontrado;
          }
        } else {
          this.ejercicio_object_selected = this.ejercicios[0];
        }
this.seleccionarEjercicio(this.ejercicio_object_selected,false);


        this.cargado = true;
        const currentUrl = this.router.url;
        if (currentUrl.includes('/contabilidad/proceso/ctb-pol') && refrescar) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {

            this.router.navigate([currentUrl]);

          });

        }
      }, err => {
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
      }
    );
    this.cargado = true;
  }

  cargarDatos() {
    this.ctbConfService.getByEmpId(this.service.usuario.empresa_seleccionada.id as number).subscribe(response => {
      this.dto = response.contenido;
      localStorage.setItem('rfc', this.dto.rfc);
      localStorage.setItem('tipo_cierre', this.dto.tipo_cierre);
    }, err => {
      if (err.error.mensaje == null) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      console.log(err);
    });
  }

  seleccionarEmpresa(empresa: any) {
    this.service.seleccionarEmpresa(empresa);
    location.reload();
  }
  ngOnInit() {
    this.PeriodoEjercicioService.ejercicio$.subscribe(ejercicio => {
      this.ejercicio_vigente = ejercicio ? ejercicio : 0;

    });
    this.PeriodoEjercicioService.periodo$
      .subscribe(periodo => {

        this.periodo_vigente = periodo ? periodo : 0;
      });
      this.PeriodoEjercicioService.ejercicio_object$.subscribe(ejercicio_object => {
        this.ejercicio_object_selected = ejercicio_object;
        console.log(this.ejercicio_object_selected);
      });

      this.PeriodoEjercicioService.periodo_object$.subscribe(periodo_object => {
        this.periodo_object_selected = periodo_object;
      });




    this.cargado = false;
    this.usuario = this.service.usuario;
    // this.ejercicios = (localStorage.getItem('ejercicios') == null ? null : JSON.parse(localStorage.getItem('ejercicios')));
    //  if (this.ejercicios == null) {
    this.cargarEjercicios(false);
    this.cargarDatos();
    //  }
    this.listTitles = ROUTES.filter(listTitle => listTitle);

    const navbar: HTMLElement = this.element.nativeElement;
    this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];
    if ($('body').hasClass('sidebar-mini')) {
      misc.sidebar_mini_active = true;
    }
    $('#minimizeSidebar').click(function () {
      const $btn = $(this);

      if (misc.sidebar_mini_active == true) {
        $('body').removeClass('sidebar-mini');
        misc.sidebar_mini_active = false;

      } else {
        setTimeout(function () {
          $('body').addClass('sidebar-mini');

          misc.sidebar_mini_active = true;
        }, 300);
      }

      // we simulate the window Resize so the charts will get updated in realtime.
      var simulateWindowResize = setInterval(function () {
        window.dispatchEvent(new Event('resize'));
      }, 180);

      // we stop the simulation of Window Resize after the animations are completed
      setTimeout(function () {
        clearInterval(simulateWindowResize);
      }, 1000);
    });

  }

  isMobileMenu() {
    if ($(window).width() < 991) {
      return false;
    }
    return true;
  }

  sidebarOpen() {
    var toggleButton = this.toggleButton;
    var body = document.getElementsByTagName('body')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);
    body.classList.add('nav-open');
    this.sidebarVisible = true;
  }
  sidebarClose() {
    var body = document.getElementsByTagName('body')[0];
    this.toggleButton.classList.remove('toggled');
    this.sidebarVisible = false;
    body.classList.remove('nav-open');
  }
  sidebarToggle() {
    if (this.sidebarVisible == false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  getTitle() {
    var titlee = this.location.prepareExternalUrl(this.location.path());
    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }
    for (let i = 0; i < this.listTitles.length; i++) {
      if (this.listTitles[i].type === "link" && this.listTitles[i].path === titlee) {
        return this.listTitles[i].title;
      } else if (this.listTitles[i].type === "sub") {
        for (let j = 0; j < this.listTitles[i].children.length; j++) {
          let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
          // console.log(subtitle)
          // console.log(titlee)
          if (subtitle === titlee) {
            return this.listTitles[i].children[j].title;
          }
        }
      }
    }
    return 'Dashboard';
  }
  
  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }
  getPath() {
    // console.log(this.location);
    return this.location.prepareExternalUrl(this.location.path());
  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
  }

  verPolizaCierre(item: any) {

    if (!item.ctb_pol_id) {
      return;
    }

    const ruta = '/contabilidad/proceso/ctb-pol/actualizar/' + item.ctb_pol_id;

    if (item.poliza_cierre_valida) {
      this.router.navigate([ruta]);
      return;
    }

    Swal.fire({
      icon: 'error',
      title: 'Póliza inválida',
      text: 'La póliza de cierre es inválida por cambios en este periodo o en periodos anteriores',
      showConfirmButton: true,
      confirmButtonText: 'Aceptar',
    }).then((result) => {

      if (result.isConfirmed) {
        this.router.navigate([ruta]);
      }

    });

  }

  verOpcionesPeriodos(item: any) {


    Swal.fire({
      icon: item.poliza_cierre_valida
        ? 'question' : 'error',
      title: item.poliza_cierre_valida
        ? 'Seleccione una opción'
        : 'Poliza invalida',
      text: item.poliza_cierre_valida
        ? 'Ya existe una póliza de cierre generada'
        : 'La póliza de cierre es inválida por cambios en este o en periodos anteriores',

      showConfirmButton: true,
      showDenyButton: true,
      showCancelButton: true,
      showCloseButton: true,

      confirmButtonText: 'Generar nuevamente',
      denyButtonText: 'Dar de baja',
      cancelButtonText: 'Ver póliza',


    }).then((result) => {


      if (result.isConfirmed) {

        this.polizaCierrePeriodo(item);

      }

      else if (result.isDenied) {
        this.bajaPolizaCierrePeriodo(item);

      }

      else if (result.dismiss === Swal.DismissReason.cancel) {

        this.verPolizaCierre(item.ctb_pol_id);

        //this.relacionarPolizaCierre(item);

      }

    });

  }


  verOpcionesEjercicio(item: any) {


    Swal.fire({
      icon: item.poliza_cierre_valida
        ? 'question' : 'error',
      title: item.poliza_cierre_valida
        ? 'Seleccione una opción'
        : 'Poliza invalida',
      text: item.poliza_cierre_valida
        ? 'Ya existe una póliza de cierre generada'
        : 'La póliza de cierre es inválida por cambios en este o en periodos anteriores',

      showConfirmButton: true,
      showDenyButton: false,
      showCancelButton: true,
      showCloseButton: true,

      confirmButtonText: 'Generar nuevamente',
      denyButtonText: 'Relacionar',
      cancelButtonText: 'Ver póliza',


    }).then((result) => {


      if (result.isConfirmed) {

        this.polizaCierreEjercicio(item);

      }

      else if (result.isDenied) {


      }

      else if (result.dismiss === Swal.DismissReason.cancel) {

        this.verPolizaCierre(item.ctb_pol_id);

        //this.relacionarPolizaCierre(item);

      }

    });

  }

  polizaCierreEjercicio(item: any) {
    if (item.poliza_cierre_anual) {

      Swal.fire({
        title: 'Advertencia',
        text: 'Esta acción borrará la póliza de cierre del ejercicio y creará una nueva ¿Está seguro de volverla a generar?',
        showCancelButton: true,
        confirmButtonText: 'Aceptar',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.irFormularioPolizaEjercicio();
        }
      });
    } else {

      this.irFormularioPolizaEjercicio();
    }

  }
  irFormularioPolizaEjercicio() {

    this.router.navigate(['contabilidad/proceso/poliza-cierre'], {
      queryParams: { tipo: 'Ejercicio' }
    });
  }


  bajaPolizaCierrePeriodo(item: any) {

    Swal.fire({
      title: '¿Está seguro de dar de baja esta póliza de cierre?',
      text: `Esta acción eliminará la póliza de cierre del periodo e invalidará las polizas de cierre posteriores`,
      showCancelButton: true,
      confirmButtonText: 'Aceptar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.ejercicioService.bajaPolizaCierrePeriodo(item.id, this.service.usuario.id).subscribe(
          response => {
            this.cargarEjercicios(true);
            Swal.fire('TNK Ledger', response.mensaje, 'success');
          }, err => {
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err.error.mensaje
            })
          });
      }
    });
  }



}
